import { FC } from 'react';
import { Box, Flex, Image, Spacer, Stack } from '@chakra-ui/react';

import Card, { CardProps } from 'components/_core/Card';
import SunshineTag from 'components/_core/SunshineTag';
import Text from 'components/_core/Text';

import { ToolboxPartner } from '../../types';

interface ToolboxCardProps extends CardProps {
  partner: ToolboxPartner;
  perkBadge?: string | null;
}

export type ToolboxCardType = FC<ToolboxCardProps>;

const ToolboxCard: ToolboxCardType = ({ partner, perkBadge, ...props }) => {
  return (
    <Card padding="0" {...props}>
      <Flex flex={1} flexDirection="column" padding="space-16">
        {partner ? (
          <Box paddingBottom="space-16">
            <Flex alignItems="center">
              {partner.logo ? (
                <Box flexShrink={0} paddingRight="space-16">
                  <Image
                    alt={`${partner.name} logo`}
                    borderRadius="radius-full"
                    boxSize="40px"
                    objectFit="cover"
                    src={partner.logo}
                  />
                </Box>
              ) : null}

              <Stack spacing="0">
                <Box lineHeight={1} noOfLines={1}>
                  <Text fontWeight="weight-500" variant="primary">
                    {partner.name}
                  </Text>
                </Box>

                <Text noOfLines={2}>{partner.catchline}</Text>
              </Stack>
            </Flex>
          </Box>
        ) : null}

        {props.children ? (
          <Box paddingBottom="space-16">
            <Text variant="primary">{props.children}</Text>
          </Box>
        ) : null}

        <Spacer />

        {perkBadge ? (
          <SunshineTag
            alignSelf="flex-start"
            icon="gift"
            noOfLines={1}
            size="sm"
          >
            {perkBadge}
          </SunshineTag>
        ) : null}
      </Flex>
    </Card>
  );
};

export default ToolboxCard;
